import React, { useState } from "react";
import { toast } from "react-toastify";
import Service from "../../Service/http";
import Pagination from "@mui/material/Pagination";
import { useQuery, useQueryClient } from "react-query";
import { BiLoader } from "react-icons/bi";
import Select from "react-dropdown-select";
import {Link} from 'react-router-dom'
import { FiEdit } from "react-icons/fi";
import { FaBug } from "react-icons/fa";
import { BeatLoader } from "react-spinners";
import { SiStatuspage } from "react-icons/si";
import { FaHistory } from "react-icons/fa";
import CreateBatchModal from "./CreateBatchModal";
import { Tooltip, Typography } from "@mui/material";

function Batch() {

  const service = new Service();

  let [batch, setBatch] = useState(null);
  let [loading, SetLoading] = useState(false);
  let [refresh, setrefresh] = useState(false);
  let [selectedTenant, setSelectedTenant] = useState("ALL TENANTS");
  let [pageSize, setPageSize] = useState(10);
  let [pageNumber, setPageNumber] = useState(1);
  let [selectedBatch, setSelectedBatch] = useState("ALL BATCHES");
  const [completedLoading, setCompletedLoading] = useState({});
  const [masterOptions, setMasterOptions] = useState([]);
  const [crawlBatchLoading, setCrawlBatchLoading] = useState(false);
  const [crawlingBatchNames, setCrawlingBatchNames] = useState([])
  const [showModal, setShowModal] = useState(false)


  let pageSizeOptions = [
    { value: 10, label: "10" },
    { value: 20, label: "20" },
    { value: 30, label: "30" },
    { value: 40, label: "40" },
    { value: 50, label: "50" },
  ];

  const {
    data: collegeOptions,
    isError: collegeError,
    refetch: refetchColleges,
  } = useQuery(["colleges", refresh], () =>
    service.get("api/getColleges").then((response) => response)
  );


  const {
    data: criteriaOptions,
    isError: criteriaError,
    refetch: refetchCriteria,
  } = useQuery(["criteria", refresh], () =>
    service.get("api/all/criteria").then((response) => response)
  );

  const {
    data: batches,
    isError: batchesError,
    refetch: refetchBatches,
    isLoading: batchesLoading,
  } = useQuery(
    ["batches", refresh, pageSize, pageNumber, selectedTenant, selectedBatch],
    () =>
      service
        .get(
          `api/getBatchesWithFilterAndPagination/${
            selectedBatch === "" ? "ALL BATCHES" : selectedBatch
          }?pageSize=${pageSize}&pageNumber=${pageNumber}`
        )
        .then((response) => response)
  );

  const {
    data,
    isError: masterError,
    refetch: refetchMasterOptions,
  } = useQuery(
    ["master", refresh],
    () => service.get("api/getMasterBatches").then((response) => response),
    {
      onSuccess(data) {
        let masterOptions = data.map((el) => ({ label : el.batch_name, value: el._id }))
        setMasterOptions([{label : "Make Master", value: "make-master"},...masterOptions]);
      },
    }
  );

  const {
    data: batchIdToNameMap,
    isError: batchIdToNameMapError,
    refetch: refetchBatchIdToNameMap,
  } = useQuery(["BatchIdToNameMap", refresh], () =>
    service.get("api/getBatchIdToNameMap").then((response) => response)
  );

  const queryClient = useQueryClient();

  const addCollegeToBatch = (collegeId, batchId) => {
    SetLoading(true);
    service
      .post("api/addCollegeToBatch", { collegeId: collegeId, batchId: batchId })
      .then((json) => {
        SetLoading(false);
        setrefresh(!refresh);
        toast.success("Added College To Batch");
      })
      .catch((error) => {
        console.error(error);
        SetLoading(false);
        toast.error("Error Occured While Adding Collge To Batch");
      });
  };

  const updateDelete = (batch_id, status) => {
    SetLoading(true)
    service
      .put("api/updateBatch", { batch_id, is_deleted: status })
      .then((json) => {
        SetLoading(false);
        toast.success(status ? 'Deleted!' : 'Restored!');
      })
      .catch((error) => {
        SetLoading(false)
        toast.error("Someting went wrong");
        console.log(error);
      });
  };

  // A function that updates "is_completed" field in the batch table
  const updateCompleted = (batch_id, status) => {
    setCompletedLoading({ id: batch_id, loading: true });
    service
      .put("api/updateBatch", { batch_id, is_completed: status })
      .then(async (json) => {
        SetLoading(false);
        toast.success("saved");
        await queryClient.invalidateQueries([
          "batches",
          refresh,
          pageSize,
          pageNumber,
          selectedTenant,
          selectedBatch,
        ]);
      })
      .catch((error) => {
        SetLoading(false);
        toast.error("Something went wrong");
        console.error(error);
      })
      .finally(() => {
        setCompletedLoading({ id: null, loading: false });
      });
  };

  const updateHandleUpdation = (batch_id, status) => {
    SetLoading(true)
    service
      .put("api/updateBatch", { batch_id, is_handle_updation_approved: status })
      .then((json) => {
        SetLoading(false);
        toast.success("saved");
      })
      .catch((error) => {
        SetLoading(false)
        toast.error("Someting went wrong");
        console.log(error);
      });
  };

  // Function that takes two parameters 'batch_id' and 'master_batch_id'
  // And updates the 'master_batch' field of the batch with 'master_batch_id'
  const updateMasterBatch = (batch_id, master_batch_id) => {
    if (batch_id == null) {
      toast.error("Invalid Batch");
      return;
    }

    if (master_batch_id == "null") {
      toast.error("Invalid Master Batch");
      return;
    }

    SetLoading(true);
    service
      .put("api/updateBatch", { batch_id, master_batch: master_batch_id })
      .then((json) => {
        setrefresh(!refresh);
        SetLoading(false);
        if (json.status === "400") {
          toast.error("This batch is already a master for another.");
        } else {
          toast.success("saved");
        }
      })
      .catch((error) => {
        toast.error("Someting went wrong");
        console.log(error);
      });
  };

  const handleBatchUsersCrawl = async (batchName) => {
    
    try {

      setCrawlBatchLoading(true);

      setCrawlingBatchNames((prev) => {
        return [...prev, batchName]
      })

      const response = await service.get(`api/batch/crawl/status/${batchName}`);
      setCrawlBatchLoading(false)

      const remainingCount = response?.data?.count;

      if(remainingCount === 0){
        toast.success(`Crawling started for ${batchName} Users`);
        await service.get(`api/batch/crawl/${batchName}`);
        toast.success(`Successfully Crawled User of ${batchName}`);
      } else {
        toast.error(`Crawling is in progress, ${remainingCount} users remaining to crawl!`)
      }
      
    } catch (error) {

      toast.error(`Unable to crawl the users for ${batchName}`)
      console.error(error);

    } finally {
      setCrawlingBatchNames((prev) => {
        return prev.filter((batch) => batch !== batchName);
      })
    }
  }

  return (
    <div className="container overflow-auto">
      <div className="container shadow bg-white row mb-5">
        <div className="text-primary mt-3 mb-3 text-left">
          <strong>Important Notes: </strong>
          <ul>
            <li>
              When the "Master" column displays "Master Batch," it indicates
              that this batch does not have a master batch; it is a standalone
              batch.
            </li>
            <li>
              If the "Master" column does not display "Master Batch," it means
              that this batch is associated with a master batch.
            </li>
            <li>
              The "Assign Master" column provides a dropdown menu where you can
              select and assign a master batch for the current batch. This
              allows you to establish relationships between batches, with one
              batch being designated as the master for others.
            </li>
          </ul>
        </div>
      <CreateBatchModal show={showModal} onHide={() => setShowModal(!showModal)} criteriaOptions={criteriaOptions}/>
        <h3 className="text-primary mt-3 mb-3 text-center">
          <strong>BATCHES</strong>
        </h3>
        <div className="d-flex justify-content-around">
          <div
            className="text-center mb-3 ms-2"
            style={{ width: "100%" }}
          >
            <input
              type="text"
              className="form-control w-100"
              placeholder="Search Batch"
              onChange={(e) => {
                setSelectedBatch(e.target.value);
                setPageNumber(1);
              }}
            />
          </div>
          <Tooltip title={ <Typography>Create New Batch</Typography> } placement="top" arrow onClick={() => setShowModal(true)} >
              <button className="custom-button bg-success text-white" style={{ height: 40, marginLeft: 10, fontWeight: 'bold' }}>AddBatch</button>
          </Tooltip>
        </div>
        {batchesLoading ? (
          <div className="text-center">
            <BiLoader size={50} />
          </div>
        ) : (
        <div className="w-100 overflow-auto">
          <table id="customers">
            <thead>
              <tr className="bg-light text-center ">
                <th className="text-center">Batch Name</th>
                <th className="text-center">Criteria Name</th>
                <th className="text-center">Master</th>
                <th className="text-center">Assign Master</th>
                <th className="text-center">Deleted</th>
                <th className="text-center">Handle Updation</th>
                <th className="text-center">College</th>
                <th className="text-center">Assign College</th>
                <th className="text-center">Completed</th>
                <th className="text-center">Crawl</th>
                <th className="text-center">Edit</th>
                <th className="text-center">History</th>
              </tr>
            </thead>
            <tbody>
              {batches?.data?.data?.map((ele, ind) => {
                return (
                  <tr key={ind} className="text-center">
                    <td className="text-secondary">
                     
                        <a
                          href={`/admin/analysis/${ele.batch_name}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {ele.batch_name}
                        </a>
                    </td>
                    <td className="text-secondary">{ele.criteria_name}</td>
                    {ele.master_batch && batchIdToNameMap ? (
                      <td className="text-secondary">
                        {batchIdToNameMap[ele.master_batch]}
                      </td>
                    ) : (
                      <td className="text-success">Master Batch</td>
                    )}
                    <td className="text-secondary">
                      <div className="form-group">
                        <Select
                          options={masterOptions}
                          searchable
                          defaultValue={ele.master_batch !== null ? masterOptions.find(el => el.value === ele.master_batch) ?? undefined : undefined}
                          onChange={(value) => {
                            updateMasterBatch(ele._id, value[0].value);
                          }}
                        />
                      </div>
                    </td>
                    <td className="text-center align-center">
                      <div className="form-check form-switch d-flex justify-content-center">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={ele.is_deleted}
                          onChange={(e) => {
                            let obj = [...batches.data.data];
                            obj[ind].is_deleted = e.target.checked;
                            updateDelete(ele._id, e.target.checked);
                          }}
                        />
                      </div>
                    </td>
                    <td className="text-center align-center">
                      <div className="form-check form-switch d-flex justify-content-center">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={ele.is_handle_updation_approved}
                          onChange={(e) => {
                            let obj = [...batches.data.data];
                            obj[ind].is_handle_updation_approved =
                              e.target.checked;
                            updateHandleUpdation(ele._id, e.target.checked);
                          }}
                        />
                      </div>
                    </td>
                    <td className="text-center align-center">
                      {ele.college_name}
                    </td>
                    <td className="text-center align-center">
                      <div className="form-group">
                        <select
                          className="form-select "
                          value={ele.college_name}
                          name="college"
                          onChange={(e) => {
                            addCollegeToBatch(e.target.value, ele._id);
                          }}
                          id="exampleSelect1"
                        >
                          <option value="null">SELECT COLLEGE</option>
                          {collegeOptions &&
                            collegeOptions?.data?.map((ele, ind) => {
                              return (
                                <option key={ind} value={ele._id}>
                                  {ele.college_name}
                                </option>
                              );
                            })}
                          <option value="null">NO COLLEGE</option>
                        </select>
                      </div>
                    </td>
                    <td className="text-center align-center">
                      {completedLoading.id === ele._id &&
                      completedLoading.loading === true ? (
                        <div class="spinner-border text-primary" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                      ) : (
                        <div className="form-check form-switch d-flex justify-content-center">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={ele.is_completed}
                            onChange={(e) => {
                              let obj = [...batches.data.data];
                              obj[ind].is_completed = e.target.checked;
                              updateCompleted(ele._id, e.target.checked);
                            }}
                          />
                        </div>
                      )}
                    </td>
                  <td>
                      { crawlBatchLoading && crawlingBatchNames.includes(ele.batch_name) ? 
                          <BeatLoader size={5} />
                        : <button
                          onClick={() => handleBatchUsersCrawl(ele.batch_name)}
                          style={{border: 0, background: 'transparent'}}
                          disabled={JSON.parse(localStorage.getItem(`${ele.batch_name}-disabled-crawling`)) >= new Date().getTime()}
                      >
                          <FaBug/>
                        </button>
                      }
                  </td>
                    <td>
                    <Link
                          to={`/admin/edit/${ele.batch_name}`}
                          target="_blank"
                        >
                          <FiEdit />
                        </Link>
                    </td>
                    <td>
                    <Link
                          to={`/admin/batch/history/${ele.batch_name}`}
                          target="_blank"
                        >
                          <FaHistory />
                        </Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        )}
        <div className="row justify-content-between align-items-center">
          <div className="col-auto pt-3 mb-3">
            <select
              className="form-select"
              onChange={(e) => {
                setPageSize(parseInt(e.target.value));
                setPageNumber(1);
              }}
              value={pageSize}
            >
              {pageSizeOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
          <div className="col-auto pt-3 mb-3">
            <Pagination
              count={batches?.data?.count}
              color="primary"
              defaultPage={1}
              page={pageNumber}
              onChange={(e, v) => {
                setPageNumber(parseInt(v));
              }}
              variant="outlined" 
              shape="rounded"
              showFirstButton
              showLastButton
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Batch;
